export const translations = {
  tr: {
    nav: { hero: "Ana Sayfa", hizmetler: "Hizmetler", teknolojiler: "Teknolojiler", projeler: "Projeler", surec: "Süreç", iletisim: "İletişim" },
    cta_quote: "Teklif Al",
    hero: {
      badge: "Yazılım Geliştirme Ajansı",
      lines: [
        { pre: "Modern Web ve Mobil", accent: "", post: "" },
        { pre: "Uygulama Çözümleri ile", accent: "", post: "" },
        { pre: "", accent: "Fikirlerinizi", post: " Hayata Geçirin" },
      ],
      sub: "Özel web geliştirme, iOS/Android mobil uygulamalar ve ölçeklenebilir yazılım mimarileri. Fikrinizden canlıya, uçtan uca teknoloji ortağınız.",
      cta1: "Projeyi Başlat",
      cta2: "Hizmetleri Keşfet",
      stats: [["50+", "Tamamlanan Proje"], ["7 Yıl", "Sektör Deneyimi"], ["%98", "Müşteri Memnuniyeti"]],
      scroll_aria: "Aşağı kaydır",
    },
    marquee: ["İNOVASYON", "TASARIM", "YAZILIM", "STRATEJİ", "MOBİL", "WEB", "BULUT"],
    services: {
      badge: "Hizmetler",
      title_pre: "Uçtan uca dijital ",
      title_accent: "ürün geliştirme",
      items: [
        { title: "Mobil Uygulama Geliştirme", desc: "iOS ve Android için native & cross-platform çözümler. Flutter ve React Native ile tek kod tabanından her platforma." },
        { title: "Özel Web Sitesi & Platform", desc: "Next.js, React ve Node.js ile hızlı, SEO uyumlu ve ölçeklenebilir web platformları." },
        { title: "UI/UX Tasarım & Prototipleme", desc: "Modern, kullanıcı odaklı ve dönüşüm odaklı arayüzler. Figma'dan piksel mükemmelliğinde koda." },
        { title: "API Entegrasyonları & Backend", desc: "Güvenli veri tabanı mimarisi, bulut altyapısı ve yüksek performanslı API sistemleri." },
      ],
    },
    tech: {
      badge: "Teknolojiler",
      title_pre: "Kullandığımız ",
      title_accent: "teknolojiler",
      desc: "Kanıtlanmış ve modern teknoloji yığınıyla, performanslı ve sürdürülebilir ürünler inşa ediyoruz.",
    },
    portfolio: {
      badge: "Projeler",
      title_pre: "Seçili ",
      title_accent: "çalışmalarımız",
      view: "İncele",
      projects: [
        { category: "Mobil Uygulama", desc: "Fintech odaklı mobil ödeme uygulaması. Anlık transfer, harcama analizi ve biyometrik güvenlik." },
        { category: "Web Platformu", desc: "SaaS analitik paneli. Gerçek zamanlı veri görselleştirme ve özelleştirilebilir raporlama." },
        { category: "IoT & Backend", desc: "Endüstriyel IoT izleme sistemi. Sensör ağı yönetimi ve akıllı enerji optimizasyonu." },
      ],
    },
    process: {
      badge: "Süreç",
      title_pre: "Çalışma ",
      title_accent: "sürecimiz",
      steps: [
        { title: "Keşif & Analiz", desc: "İş hedeflerinizi, kullanıcılarınızı ve teknik gereksinimleri derinlemesine analiz ediyoruz. Net bir yol haritası çıkarıyoruz." },
        { title: "UI/UX Tasarım", desc: "Kullanıcı akışları, wireframe'ler ve piksel mükemmelliğinde arayüz tasarımları. Onayınız olmadan koda geçmiyoruz." },
        { title: "Geliştirme & Test", desc: "Çevik metodoloji ile sprint bazlı geliştirme. Otomatik testler ve düzenli demo sunumlarıyla şeffaf ilerleme." },
        { title: "Canlıya Alma & Destek", desc: "Sorunsuz yayına alma, performans izleme ve sürekli bakım. Lansmanla bitmiyor, büyümenizle devam ediyoruz." },
      ],
    },
    contact: {
      badge: "İletişim",
      title_pre: "Projenizi ",
      title_accent: "konuşalım",
      desc: "Fikrinizi paylaşın, 24 saat içinde size özel bir yol haritası ve teklif ile dönelim.",
      info_email: "E-posta",
      info_phone: "Telefon",
      info_location: "Konum",
      location_value: "İstanbul, Türkiye",
      name_label: "Ad Soyad", name_ph: "Adınız Soyadınız",
      email_label: "E-posta", email_ph: "ornek@sirket.com",
      type_label: "Proje Türü",
      type_options: ["Web", "Mobil", "Diğer"],
      budget_label: "Bütçe Aralığı",
      budget_options: ["25.000 TL altı", "25.000 – 100.000 TL", "100.000 – 500.000 TL", "500.000 TL üzeri"],
      msg_label: "Mesaj", msg_ph: "Projenizden kısaca bahsedin...",
      select_ph: "Seçiniz",
      submit: "Gönder", submitting: "Gönderiliyor...",
      toast_select: "Lütfen proje türü ve bütçe aralığı seçin.",
      toast_success: "Talebiniz alındı! En kısa sürede size dönüş yapacağız.",
      toast_error: "Bir hata oluştu, lütfen tekrar deneyin.",
    },
    footer: {
      desc: "Modern web ve mobil uygulama çözümleri ile fikirlerinizi hayata geçiren yazılım geliştirme ajansı.",
      quick_links: "Hızlı Bağlantılar",
      social: "Sosyal Medya",
      rights: "Tüm hakları saklıdır.",
      privacy: "Gizlilik Politikası",
      kvkk: "KVKK Aydınlatma Metni",
    },
    whatsapp: {
      aria: "WhatsApp ile iletişime geç",
      message: "Merhaba, yazılım hizmetleri hakkında bilgi almak istiyorum.",
      greeting: "Merhaba, nasıl yardımcı olabiliriz?",
    },
  },
  en: {
    nav: { hero: "Home", hizmetler: "Services", teknolojiler: "Technologies", projeler: "Projects", surec: "Process", iletisim: "Contact" },
    cta_quote: "Get a Quote",
    hero: {
      badge: "Software Development Agency",
      lines: [
        { pre: "Modern Web & Mobile", accent: "", post: "" },
        { pre: "App Solutions that Bring", accent: "", post: "" },
        { pre: "", accent: "Your Ideas", post: " to Life" },
      ],
      sub: "Custom web development, iOS/Android mobile apps and scalable software architectures. Your end-to-end technology partner, from idea to launch.",
      cta1: "Start a Project",
      cta2: "Explore Services",
      stats: [["50+", "Completed Projects"], ["7 Yrs", "Industry Experience"], ["98%", "Client Satisfaction"]],
      scroll_aria: "Scroll down",
    },
    marquee: ["INNOVATION", "DESIGN", "SOFTWARE", "STRATEGY", "MOBILE", "WEB", "CLOUD"],
    services: {
      badge: "Services",
      title_pre: "End-to-end digital ",
      title_accent: "product development",
      items: [
        { title: "Mobile App Development", desc: "Native & cross-platform solutions for iOS and Android. One codebase, every platform with Flutter and React Native." },
        { title: "Custom Website & Platform", desc: "Fast, SEO-friendly and scalable web platforms built with Next.js, React and Node.js." },
        { title: "UI/UX Design & Prototyping", desc: "Modern, user-centric and conversion-focused interfaces. From Figma to pixel-perfect code." },
        { title: "API Integrations & Backend", desc: "Secure database architecture, cloud infrastructure and high-performance API systems." },
      ],
    },
    tech: {
      badge: "Technologies",
      title_pre: "Technologies ",
      title_accent: "we use",
      desc: "We build performant and sustainable products with a proven, modern technology stack.",
    },
    portfolio: {
      badge: "Projects",
      title_pre: "Selected ",
      title_accent: "works",
      view: "View",
      projects: [
        { category: "Mobile App", desc: "Fintech-focused mobile payment app. Instant transfers, spending analytics and biometric security." },
        { category: "Web Platform", desc: "SaaS analytics dashboard. Real-time data visualization and customizable reporting." },
        { category: "IoT & Backend", desc: "Industrial IoT monitoring system. Sensor network management and smart energy optimization." },
      ],
    },
    process: {
      badge: "Process",
      title_pre: "Our work ",
      title_accent: "process",
      steps: [
        { title: "Discovery & Analysis", desc: "We deeply analyze your business goals, users and technical requirements, then produce a clear roadmap." },
        { title: "UI/UX Design", desc: "User flows, wireframes and pixel-perfect interface designs. We never start coding without your approval." },
        { title: "Development & Testing", desc: "Sprint-based development with agile methodology. Transparent progress with automated tests and regular demos." },
        { title: "Launch & Support", desc: "Seamless deployment, performance monitoring and continuous maintenance. It doesn't end at launch — we grow with you." },
      ],
    },
    contact: {
      badge: "Contact",
      title_pre: "Let's discuss ",
      title_accent: "your project",
      desc: "Share your idea and we'll get back to you within 24 hours with a tailored roadmap and quote.",
      info_email: "Email",
      info_phone: "Phone",
      info_location: "Location",
      location_value: "Istanbul, Türkiye",
      name_label: "Full Name", name_ph: "Your full name",
      email_label: "Email", email_ph: "you@company.com",
      type_label: "Project Type",
      type_options: ["Web", "Mobile", "Other"],
      budget_label: "Budget Range",
      budget_options: ["Under ₺25,000", "₺25,000 – ₺100,000", "₺100,000 – ₺500,000", "Over ₺500,000"],
      msg_label: "Message", msg_ph: "Tell us briefly about your project...",
      select_ph: "Select",
      submit: "Send", submitting: "Sending...",
      toast_select: "Please select a project type and budget range.",
      toast_success: "Request received! We'll get back to you shortly.",
      toast_error: "Something went wrong, please try again.",
    },
    footer: {
      desc: "A software development agency bringing your ideas to life with modern web and mobile app solutions.",
      quick_links: "Quick Links",
      social: "Social Media",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      kvkk: "Data Protection Notice",
    },
    whatsapp: {
      aria: "Contact via WhatsApp",
      message: "Hello, I would like to get information about your software services.",
      greeting: "Hello, how can we help you?",
    },
  },
  ar: {
    nav: { hero: "الرئيسية", hizmetler: "الخدمات", teknolojiler: "التقنيات", projeler: "المشاريع", surec: "منهجية العمل", iletisim: "تواصل معنا" },
    cta_quote: "اطلب عرض سعر",
    hero: {
      badge: "وكالة تطوير البرمجيات",
      lines: [
        { pre: "حلول الويب وتطبيقات", accent: "", post: "" },
        { pre: "الجوال الحديثة لتحويل", accent: "", post: "" },
        { pre: "", accent: "أفكارك", post: " إلى واقع" },
      ],
      sub: "تطوير مواقع ويب مخصصة، تطبيقات iOS/Android، وبنى برمجية قابلة للتوسع. شريكك التقني المتكامل من الفكرة إلى الإطلاق.",
      cta1: "ابدأ مشروعك",
      cta2: "استكشف الخدمات",
      stats: [["+50", "مشروع منجز"], ["7 سنوات", "خبرة في المجال"], ["%98", "رضا العملاء"]],
      scroll_aria: "مرر للأسفل",
    },
    marquee: ["ابتكار", "تصميم", "برمجيات", "استراتيجية", "جوال", "ويب", "سحابة"],
    services: {
      badge: "الخدمات",
      title_pre: "تطوير منتجات ",
      title_accent: "رقمية متكاملة",
      items: [
        { title: "تطوير تطبيقات الجوال", desc: "حلول أصلية ومتعددة المنصات لنظامي iOS وAndroid. قاعدة كود واحدة لكل المنصات باستخدام Flutter وReact Native." },
        { title: "مواقع ومنصات ويب مخصصة", desc: "منصات ويب سريعة ومتوافقة مع محركات البحث وقابلة للتوسع باستخدام Next.js وReact وNode.js." },
        { title: "تصميم UI/UX ونماذج أولية", desc: "واجهات حديثة تركز على المستخدم والتحويل. من Figma إلى كود متقن بدقة البكسل." },
        { title: "تكامل API وأنظمة Backend", desc: "بنية قواعد بيانات آمنة، بنية تحتية سحابية، وأنظمة API عالية الأداء." },
      ],
    },
    tech: {
      badge: "التقنيات",
      title_pre: "التقنيات ",
      title_accent: "التي نستخدمها",
      desc: "نبني منتجات عالية الأداء ومستدامة باستخدام حزمة تقنيات حديثة ومثبتة.",
    },
    portfolio: {
      badge: "المشاريع",
      title_pre: "أعمالنا ",
      title_accent: "المختارة",
      view: "استعرض",
      projects: [
        { category: "تطبيق جوال", desc: "تطبيق دفع مالي متخصص. تحويلات فورية، تحليل للمصروفات، وأمان بيومتري." },
        { category: "منصة ويب", desc: "لوحة تحليلات SaaS. عرض بيانات في الوقت الفعلي وتقارير قابلة للتخصيص." },
        { category: "إنترنت الأشياء وBackend", desc: "نظام مراقبة صناعي لإنترنت الأشياء. إدارة شبكات المستشعرات وتحسين ذكي للطاقة." },
      ],
    },
    process: {
      badge: "منهجية العمل",
      title_pre: "منهجية ",
      title_accent: "عملنا",
      steps: [
        { title: "الاستكشاف والتحليل", desc: "نحلل أهداف عملك ومستخدميك والمتطلبات التقنية بعمق، ثم نضع خارطة طريق واضحة." },
        { title: "تصميم UI/UX", desc: "مسارات المستخدم، النماذج الأولية، وتصاميم واجهات بدقة البكسل. لا نبدأ البرمجة دون موافقتك." },
        { title: "التطوير والاختبار", desc: "تطوير قائم على السبرنت بمنهجية أجايل. تقدم شفاف مع اختبارات آلية وعروض تجريبية دورية." },
        { title: "الإطلاق والدعم", desc: "نشر سلس، مراقبة للأداء، وصيانة مستمرة. لا ينتهي الأمر عند الإطلاق — نستمر معك في النمو." },
      ],
    },
    contact: {
      badge: "تواصل معنا",
      title_pre: "لنتحدث عن ",
      title_accent: "مشروعك",
      desc: "شاركنا فكرتك وسنعود إليك خلال 24 ساعة بخارطة طريق وعرض سعر مخصصين.",
      info_email: "البريد الإلكتروني",
      info_phone: "الهاتف",
      info_location: "الموقع",
      location_value: "إسطنبول، تركيا",
      name_label: "الاسم الكامل", name_ph: "اسمك الكامل",
      email_label: "البريد الإلكتروني", email_ph: "you@company.com",
      type_label: "نوع المشروع",
      type_options: ["ويب", "جوال", "أخرى"],
      budget_label: "نطاق الميزانية",
      budget_options: ["أقل من 25.000 ليرة", "25.000 – 100.000 ليرة", "100.000 – 500.000 ليرة", "أكثر من 500.000 ليرة"],
      msg_label: "الرسالة", msg_ph: "حدثنا باختصار عن مشروعك...",
      select_ph: "اختر",
      submit: "إرسال", submitting: "جارٍ الإرسال...",
      toast_select: "يرجى اختيار نوع المشروع ونطاق الميزانية.",
      toast_success: "تم استلام طلبك! سنعود إليك في أقرب وقت.",
      toast_error: "حدث خطأ، يرجى المحاولة مرة أخرى.",
    },
    footer: {
      desc: "وكالة تطوير برمجيات تحوّل أفكارك إلى واقع من خلال حلول الويب وتطبيقات الجوال الحديثة.",
      quick_links: "روابط سريعة",
      social: "وسائل التواصل",
      rights: "جميع الحقوق محفوظة.",
      privacy: "سياسة الخصوصية",
      kvkk: "بيان حماية البيانات",
    },
    whatsapp: {
      aria: "تواصل عبر واتساب",
      message: "مرحباً، أود الحصول على معلومات حول خدمات البرمجيات.",
      greeting: "مرحباً، كيف يمكننا مساعدتك؟",
    },
  },
};
